import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'
import store from './store'
import i18n from './lang' // Internationalization
import './icons' // icon
import './permission' // permission control
import '@/card/init'
import { resetForm } from '@/utils/index'
import QRCode from 'qrcodejs2'

import TableView from '@/components/TableView'
import CatelogSelect from '@/views/catelog/CatelogSelect'
import DateTimeSelect from '@/components/DateTimeSelect'
import DateSelect from '@/components/DateSelect'
import TextArea from '@/components/TextArea'
import DateRangeSelect from '@/components/DateRangeSelect'

import Viser from 'viser-vue'
// import echarts from 'echarts'
//
// Vue.prototype.$echarts = echarts
Vue.prototype.resetForm = resetForm
Vue.config.productionTip = false

Vue.prototype.msgSuccess = function (msg) {
  this.$notify({title: '成功', message: msg, type: 'success', duration: 2000})
}

Vue.prototype.msgError = function (msg) {
  this.$notify({title: '失败', message: msg, type: 'error', duration: 2000})
}

Vue.prototype.msgInfo = function (msg) {
  this.$notify({title: '提示', message: msg, type: 'info', duration: 2000})
}

Vue.component('table-view', TableView)
Vue.component('catelog-select', CatelogSelect)
Vue.component('date-time-select', DateTimeSelect)
Vue.component('date-select', DateSelect)
Vue.component('el-textarea', TextArea)
Vue.component('date-range-select', DateRangeSelect)

Vue.use(Viser)
Vue.use(ElementUI, { size: 'small' })

Vue.prototype.busy = new Vue()

Vue.prototype.QRCode = function (text) {
  this.qrcode = new QRCode('qrcode', {
    width: 320,
    height: 320,
    text: text
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js